import { useCallback } from 'react';
import { ConnectionHandler, type SelectorStoreUpdater } from 'relay-runtime';

const TOTAL_ISSUES_SEARCH_RESULT_COUNT = 'totalIssueSearchResultCount';

export function useDeleteRecord(itemsConnectionId: string, recordId: string) {
	return useCallback<SelectorStoreUpdater>(
		(store) => {
			assert(itemsConnectionId, 'itemsConnectionId');
			assert(recordId, 'recordId');

			const connectionRecord = store.get(itemsConnectionId);

			if (!connectionRecord) return;

			ConnectionHandler.deleteNode(connectionRecord, recordId);

			const totalIssues = connectionRecord.getValue(TOTAL_ISSUES_SEARCH_RESULT_COUNT);

			if (totalIssues != null && typeof totalIssues === 'number') {
				if (totalIssues >= 1) {
					connectionRecord.setValue(totalIssues - 1, TOTAL_ISSUES_SEARCH_RESULT_COUNT);
				}
			}
		},
		[itemsConnectionId, recordId],
	);
}

function assertString(value: unknown, paramName: string): asserts value is string {
	if (typeof value !== 'string') throw new Error(`${paramName} must be a string`);
}

function assertNotEmpty(value: string, paramName: string) {
	if (value.trim().length === 0) throw new Error(`${paramName} must not be an empty string`);
}

function assert(value: string, paramName: string) {
	assertString(value, paramName);
	assertNotEmpty(value, paramName);
}
